import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setErrorMessage, setIsLoading } from '../app/store/majesticSlice';
import { useTranslation } from 'react-i18next';

const documentTypeList = ['SELFIE', 'DL_FRONT', 'PASSPORT', 'BARCODE'];


const getDocumentType = (documentType) => {
  // DL_FRONT => ID
  // BARCODE
  // PASSPORT
  // SELFIE
  if (documentType === 'INE' || documentType === 'CEDULA') {
    return 'DL_FRONT';
  }

  return documentType;
};

function useMitekSDK() {
  const { documentType } = useSelector((state) => state.ocr);
  const [captureSuccess, setCaptureSuccess] = useState(false);
  const [imageData, setImageData] = useState();
  const [txtFeedBack, setTxtFeedBack] = useState('TXT_MITEK_ERROR_CENTER_DOCUMENT');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const processStop = useCallback(() => {
    const { mitekScienceSDK } = window;
    if (mitekScienceSDK) {
      console.log('processStop');
      mitekScienceSDK.cmd('SDK_STOP');
    }
  }, []);

  const startCaptureProcess = useCallback(() => {
    if (documentType === '') {
      throw new TypeError('TXT_THROW_ERROR_SELECTED_TYPEDOCUMENT');
    }

    console.log('init startCaptureProcess')
    // may be needed to address new browser standards (explicit video play)
    document.querySelector('div video[autoplay="true"]').play();
    const { mitekScienceSDK } = window;

    mitekScienceSDK.on('CAMERA_DISPLAY_STARTED', (result) => {
      // show the first initial hint message
      console.log('CAMERA_DISPLAY_STARTED');
      dispatch(setIsLoading(false));
      // mitekScienceSDK.cmd('SHOW_HINT', '<b className="typeDocument">'+textLabel+'</b><br><b className="messageDocument">'+ t('TXT_MITEK_ERROR_CENTER_DOCUMENT') +'</b>');
    });

    mitekScienceSDK.on('FRAME_PROCESSING_FEEDBACK', (result) => {
      console.log('FRAME_PROCESSING_FEEDBACK', result);
      const { key: recentHint } = result;
      if (recentHint !== null) {
        let hintMsg = t(`TXT_${recentHint}`)
        if (recentHint === 'TXT_MITEK_ERROR_FOUR_CORNER') {
          hintMsg = t('TXT_MITEK_ERROR_CENTER_DOCUMENT');
        }
        setTxtFeedBack(hintMsg);
      }
    });

    mitekScienceSDK.on('FRAME_PROCESSING_STARTED', (result) => {
      console.log('FRAME_PROCESSING_STARTED', result);
    });

    mitekScienceSDK.on('FRAME_CAPTURE_RESULT', (result) => {
      console.log('FRAME_CAPTURE_RESULT', result);
      const { imageData: imageBase64 } = result.response;

      // const selectedDocumentType = localStorage.getItem('documentType');
      // const imageFront = localStorage.getItem('imageFront');
      // const imageReverse = localStorage.getItem('imageReverse');

      // if (selectedDocumentType === 'INE') {
      //   if (imageReverse === null && imageFront !== '') {
      //     localStorage.setItem('imageReverse', imageData);
      //   } else {
      // localStorage.setItem('imageFront', imageData);
      //   }
      // }

      // dispatch(setPicture(imageData));
      setImageData(imageBase64);
      setCaptureSuccess(true);
      mitekScienceSDK.cmd('SDK_STOP');
      // setTimeout(() => {
      //   navigate('/DocumentPreview');
      // }, 1500);
    });

    mitekScienceSDK.on('SDK_ERROR', (err) => {
      dispatch(setIsLoading(false));
      dispatch(setErrorMessage({ message: t('TXT_ERROR_GETTING_CAMERA') }));
    });

    mitekScienceSDK.cmd('CAPTURE_AND_PROCESS_FRAME', {
      documentType: getDocumentType(documentType),
      mode: 'AUTO_CAPTURE',
      mitekSDKPath: '/js/mitek/mitekSDK/',
      options: {
        // value between 50 to 100 recommended
        qualityPercent: 80,
        // how long the hint message displays (in MS) / note: 2400 recommended for screen readers
        hintFrequencyMS: 1200,
        // screen reader setting for hint updates value (0=off / 1=polite / 2=assertive)
        hintAriaLive: 2,
        // size of the overlay guide  (1=large, 2=medium, 3=small) / note: 1 is recommended
        guidePaddingLevel: 1,
        // set the size of the hint message (1=small / 2=medium / 3=large)
        hintMessageSize: 1,
        // disable smile detection
        disableSmileDetection: false,
        // determines how strict face detection is (1=lenient, 2=moderate, 3=strict)
        faceDetectionLevel: 1,
        // (optionally) embed the video in a custom HTML container
        videoContainerId: 'mitek-content-video',
        // (optionally) record the video session / returned as a dataURL
        videoRecordingEnabled: false,
        // (optionally) also record audio / only applies if videoRecordingEnabled = true)
        audioRecordingEnabled: false,
        // eslint-disable-next-line max-len
        // (optionally) value between 30 to 100 recommended (normalized bitrate of video / only applies if videoRecordingEnabled = true)
        videoQuality: 70,
        // eslint-disable-next-line max-len
        // (optionally) override the default "Recording" message / Note: set to "" to disable icon and message\
        videoRecordingMessage: 'Recording',
      },
    });
  }, [dispatch, documentType, t]);

  const directFileInputProcess = (fileData) => {
    const { mitekScienceSDK } = window;
    let isSuccess = true;

    mitekScienceSDK.on('FRAME_PROCESSING_FEEDBACK', (result) => {
      // console.log('FRAME_PROCESSING_FEEDBACK', result);
      const { key: recentHint, status } = result;

      if (status === 'failure') {
        if (recentHint !== null) {
          let hintMsg = t(`TXT_ATTACHED_FILE_${recentHint}`) /*generalHints[recentHint]*/;
          if (recentHint === 'TXT_ATTACHED_FILE_MITEK_ERROR_FOUR_CORNER') {
            hintMsg = t('TXT_ATTACHED_FILE_MITEK_ERROR_CENTER_DOCUMENT');
          }
          // mitekScienceSDK.cmd('SHOW_HINT', '<b className="typeDocument">'+textLabel+'</b><br><b className="messageDocument">'+hintMsg+'</b>');
          console.log(hintMsg);
          dispatch(setErrorMessage(hintMsg));
          dispatch(setIsLoading(false));
          isSuccess = false;
        }
      }
    });

    mitekScienceSDK.cmd('PROCESS_FRAME', {
      documentType: getDocumentType(documentType),
      mitekSDKPath: '/js/mitek/mitekSDK/',
      options: {
        sourceType: 'file_input',
        frame: fileData,
        qualityPercent: 80,
      },
    });

    mitekScienceSDK.on('FRAME_CAPTURE_RESULT', (result) => {
      const { imageData: imageBase64 } = result.response;

      if (isSuccess) {
        // console.log('Direct Science Result', imageData);
        setCaptureSuccess(true);
        setImageData(imageBase64);
      }

      mitekScienceSDK.cmd('SDK_STOP');
    });

    mitekScienceSDK.on('SDK_ERROR', (err) => {
      console.log('direct input error', err);
    });
  };

  return {
    imageData,
    captureSuccess,
    startCaptureProcess,
    processStop,
    directFileInputProcess,
    txtFeedBack,
  };
}

export default useMitekSDK;
